export default "__VITE_ASSET__BOZN4OSR__ 100w";